module.exports = __webpack_public_path__ + "static/img/record.064f25c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/record.gif
// module id = uCMd
// module chunks = 1